import { createSelector, createSlice } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux'
import { selectCategoryCounts } from '~map-preview/states/map'

export const MARKER_TYPES = {
  INDIVIDUAL: 'individual',
  CLUSTERS: 'clusters',
  CATEGORIES: 'categories'
}

export const initialState = {
  type: 'individual',
  category: undefined
}

export const markerSlice = createSlice({
  name: 'marker',
  initialState,
  reducers: {
    setType: (state, action) => {
      const type = action.payload
      state.type = type
    },

    setCategory: (state, action) => {
      state.category = action.payload
    }
  }
})

export const { setType, setCategory } = markerSlice.actions

export const selectMarkerType = (state) => state.marker.type
export const selectMarkerCategory = (state) => state.marker.category

const selectMarkerTypeOptions = createSelector(
  selectCategoryCounts,
  (categoryCounts) => {
    const options = [
      {
        label: 'Individual',
        value: MARKER_TYPES.INDIVIDUAL
      }
    ]

    if (categoryCounts >= 1) {
      options.push({
        label: 'Categories',
        value: MARKER_TYPES.CATEGORIES
      })
    }

    return options
  }
)

export const useMarkerType = () => useSelector(selectMarkerType)
export const useMarkerCategory = () => useSelector(selectMarkerCategory)
export const useMarkerTypeOptions = () => useSelector(selectMarkerTypeOptions)

export default markerSlice.reducer
